import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Overlay } from '@angular/cdk/overlay';

import { CommonDialogComponent } from '../components/common-dialog/common-dialog.component';
import { CommonDialogData } from '../models/dialog.model';

@Injectable({
  providedIn: 'root'
})
export class ServerErrorDialogService {
  private activeDialogRef: MatDialogRef<CommonDialogComponent> | null = null;

  constructor(
    private dialog: MatDialog,
    private overlay: Overlay
  ) {}

  showServerError(message: string): void {
    if (this.activeDialogRef) {
      return;
    }

    const dialogConfig: MatDialogConfig = {
      autoFocus: false,
      panelClass: 'bpx-dialog-container',
      scrollStrategy: this.overlay.scrollStrategies.noop(),
      data: {
        title: 'Server Error',
        message,
        okText: 'OK',
        dismissText: '',
        okAction: () => {},
        dismissAction: () => {}
      } as CommonDialogData
    };

    this.activeDialogRef = this.dialog.open(CommonDialogComponent, dialogConfig);
    this.activeDialogRef.afterClosed().subscribe(() => {
      this.activeDialogRef = null;
    });
  }
}
